import React from 'react';
import PropTypes from 'prop-types';
import PriceI18NHOC from '../../hoc/PriceI18NHOC';

export const PriceFormatterComponent = ({price}) => (
  <span>
  {price.prefix}
    {price.amount}
    {' '}
    <span className="currency">{price.currencyCode}</span>
</span>
);

PriceFormatterComponent.PropTypes = {
  price:PropTypes.shape({
    amount:PropTypes.string.isRequired,
    currencyCode:PropTypes.string.isRequired,
    prefix: PropTypes.string,
  }).isRequired,
};

export default PriceI18NHOC(PriceFormatterComponent);
